// extracted by css-extract-rspack-plugin
export default {"cls1":"common-cls1_Iw8","cls2":"common-cls2_kbn common-cls1_Iw8","altLook":"common-altLook_DtO"};